import axios from 'axios';
import { getDate, getTime } from '../utils/dateUtil';
import { SHORT_WEATHER_BASE_TIME, MID_WEATHER_CODE, MID_TEMP_CODE } from '../utils/midCodes';
import { getAddress as krGetAddress } from './addressApi.kr';
import * as intl from './weatherApi.intl';

const SERVICE_KEY = "TmikG+/VtvpbhG3XT0uHupQLPrbAE3/kRR1Hp2fR1uyBp6Kzbwpe36iI6lg0a3eEC/vMrYBzPj0k0hmXWdHugg==";

// 위경도 → 기상청 격자(nx, ny) 변환 (LCC DFS)
// code:"toXY"(v1=위도, v2=경도 → x,y) / "toLL"(v1=x, v2=y → lat,lng)
export const convertLatLot = (code, v1, v2) => {
    let RE = 6371.00877;   // 지구 반경(km)
    let GRID = 5.0;        // 격자 간격(km)
    let SLAT1 = 30.0;      // 투영 위도1(degree)
    let SLAT2 = 60.0;      // 투영 위도2(degree)
    let OLON = 126.0;      // 기준점 경도(degree)
    let OLAT = 38.0;       // 기준점 위도(degree)
    let XO = 43;           // 기준점 X좌표(GRID)
    let YO = 136;          // 기준점 Y좌표(GRID)

    let DEGRAD = Math.PI / 180.0;
    let RADDEG = 180.0 / Math.PI;

    let re = RE / GRID;
    let slat1 = SLAT1 * DEGRAD;
    let slat2 = SLAT2 * DEGRAD;
    let olon = OLON * DEGRAD;
    let olat = OLAT * DEGRAD;

    let ra, theta;

    let sn = Math.tan(Math.PI * 0.25 + slat2 * 0.5) / Math.tan(Math.PI * 0.25 + slat1 * 0.5);
    sn = Math.log(Math.cos(slat1) / Math.cos(slat2)) / Math.log(sn);
    let sf = Math.tan(Math.PI * 0.25 + slat1 * 0.5);
    sf = Math.pow(sf, sn) * Math.cos(slat1) / sn;
    let ro = Math.tan(Math.PI * 0.25 + olat * 0.5);
    ro = re * sf / Math.pow(ro, sn);
    let rs = {};
    if (code === "toXY") {
        rs['lat'] = v1;
        rs['lng'] = v2;
        ra = Math.tan(Math.PI * 0.25 + (v1) * DEGRAD * 0.5);
        ra = re * sf / Math.pow(ra, sn);
        theta = v2 * DEGRAD - olon;
        if (theta > Math.PI) theta -= 2.0 * Math.PI;
        if (theta < -Math.PI) theta += 2.0 * Math.PI;
        theta *= sn;
        rs['x'] = Math.floor(ra * Math.sin(theta) + XO + 0.5);
        rs['y'] = Math.floor(ro - ra * Math.cos(theta) + YO + 0.5);
    } else {
        rs['x'] = v1;
        rs['y'] = v2;
        let xn = v1 - XO;
        let yn = ro - v2 + YO;
        ra = Math.sqrt(xn * xn + yn * yn);
        if (sn < 0.0) ra = -ra;
        let alat = Math.pow((re * sf / ra), (1.0 / sn));
        alat = 2.0 * Math.atan(alat) - Math.PI * 0.5;

        if (Math.abs(xn) <= 0.0) {
            theta = 0.0;
        } else {
            if (Math.abs(yn) <= 0.0) {
                theta = Math.PI * 0.5;
                if (xn < 0.0) theta = -theta;
            } else theta = Math.atan2(xn, yn);
        }
        let alon = theta / sn + olon;
        rs['lat'] = alat * RADDEG;
        rs['lng'] = alon * RADDEG;
    }
    return rs;
};

// 현재 시각 기준 최신 단기예보 발표시각(base_date, base_time) 산정
const resolveBaseDateTime = () => {
    let nowTime = getTime();
    let last = SHORT_WEATHER_BASE_TIME[SHORT_WEATHER_BASE_TIME.length - 1];

    if (last < nowTime) {
        return { baseDate: getDate(), baseTime: last };
    }
    if (SHORT_WEATHER_BASE_TIME[0] > nowTime) {
        return { baseDate: getDate(-1, "D"), baseTime: last };
    }
    let baseTime = SHORT_WEATHER_BASE_TIME[0];
    for (let i = 0; i < SHORT_WEATHER_BASE_TIME.length; i++) {
        if (parseInt(SHORT_WEATHER_BASE_TIME[i]) > parseInt(nowTime)) {
            baseTime = SHORT_WEATHER_BASE_TIME[i - 1];
            break;
        }
    }
    return { baseDate: getDate(), baseTime };
};

// 단기예보 (기상청 getVilageFcst, param: {lat, lng})
export const getShortWeather = (param, succFun, failFun) => {
    let grid = convertLatLot("toXY", param.lat, param.lng);
    let { baseDate, baseTime } = resolveBaseDateTime();

    let url = "https://apis.data.go.kr/1360000/VilageFcstInfoService_2.0/getVilageFcst";
    url += "?serviceKey=" + encodeURIComponent(SERVICE_KEY);
    url += "&pageNo=1&numOfRows=1000&dataType=JSON";
    url += "&nx=" + grid.x + "&ny=" + grid.y;
    url += "&base_date=" + baseDate + "&base_time=" + baseTime;

    axios.get(url)
        .then((response) => {
            if (response && response.data && response.data.response
                && response.data.response.header
                && response.data.response.header.resultCode === "00") {

                let items = response.data.response.body.items.item;
                let timeData = {};
                for (let i = 0; i < items.length; i++) {
                    let key = "D" + items[i].fcstDate + items[i].fcstTime;
                    if (!timeData[key]) timeData[key] = {};
                    timeData[key][items[i].category] = items[i].fcstValue;
                }
                succFun(timeData);
            } else {
                console.error("기상청 단기예보 응답 오류:", response && response.data);
                if (failFun) failFun(response);
            }
        })
        .catch((err) => {
            console.error("기상청 단기예보 API error:", err);
            if (failFun) failFun(err);
        });
};

// ─── 중기예보 (4~6일차) ───

// 주소 문자열로 regId 매칭 (include 있으면 그 중 하나 포함해야 매칭, 강원 영동/영서 구분)
const matchRegId = (addressName, table) => {
    for (let i = 0; i < table.length; i++) {
        let item = table[i];
        if (addressName.indexOf(item.key) > -1) {
            let isMatch = true;
            if (item.include) {
                isMatch = item.include.some((val) => addressName.indexOf(val) > -1);
            }
            if (isMatch) return item.code;
        }
    }
    return null;
};

// 중기예보 발표시각(tmFc): 4일차는 06시 발표만 제공. 06시 이후면 오늘 0600, 이전이면 어제 0600.
const resolveMidTmFc = () => {
    if (parseInt(getTime()) > 600) {
        return getDate() + "0600";
    }
    return getDate(-1, "D") + "0600";
};

// 중기육상예보 (강수확률/오전·오후 날씨) → [{day, rainRate, morning, afternoon}]
const fetchMidLand = (regId) => {
    let url = "https://apis.data.go.kr/1360000/MidFcstInfoService/getMidLandFcst";
    url += "?serviceKey=" + encodeURIComponent(SERVICE_KEY);
    url += "&pageNo=1&numOfRows=10&dataType=JSON&regId=" + regId + "&tmFc=" + resolveMidTmFc();
    return axios.get(url).then((response) => {
        if (response && response.data && response.data.response
            && response.data.response.header
            && response.data.response.header.resultCode === "00") {
            let items = response.data.response.body.items.item[0];
            let arr = [];
            for (let i = 4; i < 7; i++) {
                let am = items["rnSt" + i + "Am"], pm = items["rnSt" + i + "Pm"];
                arr.push({
                    day: i,
                    rainRate: am > pm ? am : pm,
                    morning: items["wf" + i + "Am"],
                    afternoon: items["wf" + i + "Pm"]
                });
            }
            return arr;
        }
        return null;
    });
};

// 중기기온예보 (최저/최고) → [{day, minTemp, maxTemp}]
const fetchMidTa = (regId) => {
    let url = "https://apis.data.go.kr/1360000/MidFcstInfoService/getMidTa";
    url += "?serviceKey=" + encodeURIComponent(SERVICE_KEY);
    url += "&pageNo=1&numOfRows=10&dataType=JSON&regId=" + regId + "&tmFc=" + resolveMidTmFc();
    return axios.get(url).then((response) => {
        if (response && response.data && response.data.response
            && response.data.response.header
            && response.data.response.header.resultCode === "00") {
            let items = response.data.response.body.items.item[0];
            let arr = [];
            for (let i = 4; i < 7; i++) {
                arr.push({ day: i, minTemp: items["taMin" + i], maxTemp: items["taMax" + i] });
            }
            return arr;
        }
        return null;
    });
};

// 중기예보 (param: {lat, lng}) — 역지오코딩→regId 매칭→육상+기온 병렬→day 병합. 실패 시 Open-Meteo 폴백.
export const getDailyForecast = (param, succFun, failFun) => {
    const fallback = () => intl.getDailyForecast(param, succFun, failFun);

    krGetAddress(param.lng, param.lat, (addr) => {
        if (!addr || !addr.address_name) return fallback();

        let regIdLand = matchRegId(addr.address_name, MID_WEATHER_CODE);
        let regIdTemp = matchRegId(addr.address_name, MID_TEMP_CODE);
        if (!regIdLand || !regIdTemp) return fallback();

        Promise.all([fetchMidLand(regIdLand), fetchMidTa(regIdTemp)])
            .then(([land, temp]) => {
                if (!land || !temp) return fallback();
                let merged = land.map((l) => {
                    let t = temp.find((x) => x.day === l.day) || {};
                    return {
                        day: l.day,
                        rainRate: l.rainRate,
                        morning: l.morning,
                        afternoon: l.afternoon,
                        minTemp: t.minTemp,
                        maxTemp: t.maxTemp
                    };
                });
                succFun(merged);
            })
            .catch((err) => {
                console.error("기상청 중기예보 병합 error:", err);
                fallback();
            });
    });
};
